import usePhotos from '../../hooks/usePhotos';

// A member of staff's avatar: their photo when they have set one, otherwise the
// initials circle the caller describes. Takes the same className and style the
// initials element had, so a site swaps its tag for this and nothing else moves.
export default function Avatar({ personId, as: Tag = 'div', className = '', style, children, ...rest }) {
  const src = usePhotos()[personId];
  if (src) return <img src={src} alt="" className={`${className} object-cover`} style={style} {...rest} />;
  return <Tag className={className} style={style} {...rest}>{children}</Tag>;
}
